import type { MarkdownPost } from "../../data/types";

export const markdown_posts: MarkdownPost[] = [
    {
        kind: "md",
        slug: "the-joy-of-the-royal-rumble-on-netflix",
        name: "The Joy of The Royal Rumble on Netflix",
        subtitle: "",
        date: "30 JANUARY 2026",
        reviewer: {
            name: "Andy O'Sullivan",
            twitter: "https://bsky.app/profile/andyosullivan.bsky.social",
        },
        hero: { image: "wwe_002.jpg", alt: "Yeet!", text: "Yeet!" },


        // NOTE: Images are LOCAL via asset:filename.ext (see renderer below)
        content: `
## The Joy of the Royal Rumble on Netflix

I had more or less given up on Netflix, home of generic content, until I realised that they had
so much WWE content. Not just RAW and Smackdown (the two weekly live shows), but also all the pay-per-view
events - and I mean ALL of them, from years ago until now. I've been an on and off fan of WWE since I
was a kid, sometimes going years without watching it, but somehow I always find myself back watching it.
From the early days of Hulk Hogan, the Ultimate Warrior and Macho Man Randy Savage, to the Rock, Stone Cold and Triple
H, to Cody Rhodes & Becky Lynch - I've watched and enjoyed.

The Royal Rumble was always the best event each year. 30 wrestlers enter the ring, 90 seconds apart, and last man (or woman in the women's event)
not thrown over the top ropes wins. Simple but so much fun. When each 90 seconds ticks down to 0, the crowd start
chanting 5 - 4 - 3 - 2 - 1 then the klaxon goes off, followed by the entrance music of the next superstar. Who will it be?
Excitement, surprise, anticipation, it has it all. 

The problem with the Royal Rumble was that it was a pay-per-view,
and I never paid to view - but now it's on Netflix, I can watch it (not actually for free as I pay Netflix!) at my 
leisure, and watch all the old ones aswell! Two of my kids and I started by watching the most recent event from 2025, and
we've been working backwards, going back a year each time we finish one! That might sound a bit counterintuitive but
it's been a lot of fun. "Look how young CM looks!" ... "Who's that?" ... "JEFF HARDY!".

![A huge entrance pop](asset:wwe_003.jpg "The Man")

The key to understanding the appeal of wrestling is understanding that it is basically live theatre.
Yes, it is "fake", but it's top performers acting out rivalries, vendettas, story arcs in the most
over the top and entertaining fashion possible. I like the entrances, the promos, the backstage antics
even more than I like the actual fighting, and the Royal Rumble isn't really about wrestling, it's really
about who's next when the timer counts down. The nature of the contest - getting people over the top rope - means that there's very little proper wrestling on show, just a lot of pushing, punching and people
pretending to be tired as they cling onto ropes; but we don't care, it's still glorious drama.

So this weekend, we're going to watch the latest Royal Rumble - the kids are already talking about 
whether Finn Bálor will manage to get into the 30 men, or whether Cody Rhodes will last the full event.
Popcorn, sweets, human drama, what more could you want?


**Rating:** 5 stars
`,
    },
];
